import * as React from 'react';

interface UseSearchableFieldFilterReturn {
	searchValue: string;
	handleSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	handleSearchClear: () => void;
	filterItems: <T>(items: T[], getSearchableText: (item: T) => string) => T[];
}

export const useSearchableFieldFilter = (): UseSearchableFieldFilterReturn => {
	const [searchValue, setSearchValue] = React.useState('');

	const handleSearchChange = React.useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
		setSearchValue(event.target.value);
	}, []);

	const handleSearchClear = React.useCallback(() => {
		setSearchValue('');
	}, []);

	const filterItems = React.useCallback(
		<T>(items: T[], getSearchableText: (item: T) => string): T[] => {
			if (!searchValue) return items;

			return items.filter(item => {
				const text = getSearchableText(item);
				return text.toLocaleLowerCase().indexOf(searchValue.toLocaleLowerCase()) > -1;
			});
		},
		[searchValue]
	);

	return {
		searchValue,
		handleSearchChange,
		handleSearchClear,
		filterItems,
	};
};
